import PaymentDialogState from '../State/PaymentDialogState'
import Action, { ActionPaymentDialog ,ActionType } from '../Actions/ActionTypes'
import { Reducer } from 'redux'

const text = (oldState: PaymentDialogState, action: Action): PaymentDialogState => {
    let text = (action as ActionPaymentDialog).text
    let error : string | undefined = undefined
    if(text.length > 0 && +text < 10000){
        error = "مبلغ باید بیشتر از 10,000 تومان باشد"
    }
    return { ...oldState, text : text, error : error}
}

type Process = (oldState: PaymentDialogState, action: Action) => PaymentDialogState

export const PaymentDialogReducer: Reducer<PaymentDialogState, Action> = (state: PaymentDialogState = { text : '' , error :  undefined}, action: Action): PaymentDialogState => {

    let actionMap = new Map<ActionType, Process>()

    actionMap.set(ActionType.AMOUNT_TEXT, text)

    return actionMap.get(action.type)?.call(undefined, state, action) ?? state

}


